module.exports = __webpack_public_path__ + "img/bttn-close-black.c411be81.svg";